var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_8","data-name":"Path 8","d":"M31.084,15.542A15.542,15.542,0,1,0,13.114,30.9V20.035H9.167V15.542h3.946V12.118c0-3.9,2.32-6.047,5.87-6.047a23.9,23.9,0,0,1,3.479.3V10.2H20.5a2.246,2.246,0,0,0-2.533,2.427v2.915h4.31l-.689,4.493H17.97V30.9A15.546,15.546,0,0,0,31.084,15.542Z","fill":"#fafafa"}));
}

Facebook.defaultProps = {"id":"Group_489","data-name":"Group 489","width":"31.084","height":"30.895","viewBox":"0 0 31.084 30.895"};

module.exports = Facebook;

Facebook.default = Facebook;
